/** Minimum viewport width (px) at which each banner image size is preferred. */
export const BANNER_VIEWPORT_MIN_WIDTHS = {
    large: 1440,
    medium: 441,
    small: 0,
};

export function formatBannerSizeViewportRange(size) {
    const largeMinWidth = BANNER_VIEWPORT_MIN_WIDTHS.large;
    const mediumMinWidth = BANNER_VIEWPORT_MIN_WIDTHS.medium;

    if (size === 'large') {
        return `${largeMinWidth}px+`;
    }

    if (size === 'medium') {
        return `${mediumMinWidth}px–${largeMinWidth - 1}px`;
    }

    return `up to ${mediumMinWidth - 1}px`;
}

export function resolveBannerImageForViewport(images, viewportWidth, fallbackImages = true) {
    if (!images) {
        return null;
    }

    if (viewportWidth >= BANNER_VIEWPORT_MIN_WIDTHS.large) {
        return fallbackImages
            ? (images.large ?? images.medium ?? images.small)
            : images.large;
    }

    if (viewportWidth >= BANNER_VIEWPORT_MIN_WIDTHS.medium) {
        return fallbackImages
            ? (images.medium ?? images.large ?? images.small)
            : images.medium;
    }

    return fallbackImages
        ? (images.small ?? images.medium ?? images.large)
        : images.small;
}

function capitalize(value) {
    return value.charAt(0).toUpperCase() + value.slice(1);
}

export const BANNER_IMAGE_SIZES = ['large', 'medium', 'small'].map((size) => ({
    size,
    label: `${capitalize(size)} (${formatBannerSizeViewportRange(size)})`,
}));
